import { FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { RootState } from "../../../Redux/store";
import { skipToken } from "@reduxjs/toolkit/query";
import { useRecentProductQuery } from "../../../Redux/Api/ProductAPI";

export interface Product {
    _id: string;
    name: string;
    image: string;
}
interface RecentlyViewedProps {
    products: Product[];
}

const RecentlyViewed = ({ products }: RecentlyViewedProps) => {
    return (
        <div className="w-full bg-white pb-4 pt-6 pl-4">
            <div className="flex items-center gap-2 mb-4">
                <div className="p-1.5 bg-gray-100 rounded-full">
                    <FiEye className="text-gray-700 text-lg" />
                </div>
                <h4 className="text-[15px] font-bold text-gray-800 tracking-wide">Recent Viewed</h4>
            </div>

            <div className="flex gap-4 overflow-x-auto pb-2 no-scrollbar pr-4">
                {products?.map((item: Product) => (
                    <div key={item._id} className="flex-shrink-0 w-[90px] bgg10">
                        <img src={item.image} alt={item.name} className="w-[90px] h-[97px] mb-[2px] object-cover rounded border border-gray-200" />
                        <p className="truncate text-[10px] font-medium text-gray-400">{item.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentlyViewed;
